export default __webpack_public_path__ + "static/media/isko_updated.4a3f8b35.svg";